import styled from 'styled-components';
import { Skeleton } from 'antd';

import { CustomThemeToken } from '@/theme';

export const Container = styled.div<{ theme: { token: CustomThemeToken } }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .user-form-header-skeleton {
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .fit-content {
    width: fit-content;
  }

  .favourite-star-column {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    margin-right: -${({ theme: { token } }) => token.marginMD}px;
  }

  > header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    > div:first-child {
      display: flex;
      flex-direction: column;
    }

    h1 {
      margin-bottom: 3px;
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    }

    .last-updated-label {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      margin-bottom: 3px;
    }
  }

  .ant-form {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    header {
      display: flex;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
      gap: 12px;
    }

    header .ant-form-item {
      flex: 1 1 0px;
    }

    header .ant-form-item-control {
      flex: 1;
    }

    .centered-switch {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important; /* centers label + switch horizontally */
    }

    .centered-switch .ant-form-item-label {
      display: flex;
      align-items: center;
      white-space: nowrap;
      flex: 0 0 auto;
    }

    .centered-switch .ant-form-item-control {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .centered-switch .ant-switch {
      width: auto !important;
      min-width: auto !important;
    }

    header input,
    header .ant-input,
    header .ant-select,
    header .ant-select-selector {
      width: 100% !important;
      min-width: 0; /* critical: allow shrinking */
    }

    .horizontal-line {
      height: 1px;
      margin: 0;
      background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
    }

    .user-stations-container {
      flex-grow: 1;
      overflow: hidden;
      height: calc(100vh - 410px);

      h2 {
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }

      table {
        width: 100%;
        table-layout: fixed;

        thead {
          font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
          tr {
            th {
              background-color: ${({ theme: { token } }) => token.Ecoplant_Compressor.headerBg};
              &:first-child {
                width: 260px;
              }

              &:nth-child(2) {
                width: 260px;
              }

              &:nth-child(3) {
                width: 100%;
              }

              &:last-child {
                width: 40px;
              }

              text-align: left;

              &:first-child {
                padding-left: 0;
              }

              &:last-child {
                padding-right: 0;
              }
            }

            &:last-child {
              border-bottom: 2px solid ${({ theme: { token } }) => token.colorBorder};
            }
          }
        }

        tbody {
          background-color: ${({ theme: { token } }) => token.colorBgLayout};

          tr {
            border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorder};

            &.row-plus-button {
              border-bottom: none;
            }

            td {
              padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.padding}px;
              vertical-align: top;

              &:first-child {
                padding-left: 0;
              }

              &:last-child {
                padding-right: 0;
              }

              .notification-settings-row-container {
                display: flex;
                align-items: stretch;

                & > div {
                  align-items: center;
                }

                .severity-container {
                  display: flex;
                  flex: 0 0 160px;

                  .label {
                    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
                    font-size: ${({ theme: { token } }) => token.fontSize}px;
                    color: ${({ theme: { token } }) => token.colorTextTertiary};
                  }
                }

                .notification-description-container {
                  flex-grow: 1;
                  display: flex;
                  align-items: center;
                  justify-content: left;
                  color: ${({ theme: { token } }) => token.colorTextTertiary};
                }

                .notification-preference-container {
                  flex: 0 0 230px;
                  display: flex;
                  justify-content: space-between;

                  .unselect-container {
                    cursor: pointer;
                    margin-top: ${({ theme: { token } }) => token.marginXS}px;
                    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
                    width: 100%;
                    border-top: 1px solid ${({ theme: { token } }) => token.colorTextTertiary};
                    display: flex;
                    align-items: center;

                    span.anticon {
                      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
                      margin-right: ${({ theme: { token } }) => token.marginXXS}px;
                    }
                  }
                }
              }

              .ant-form-item {
                margin-bottom: 0;
              }

              .sms-form-item {
                margin-left: ${({ theme: { token } }) => token.marginXS}px;
              }

              button:not([disabled]):hover .btn-remove-user-station {
                path {
                  fill: ${({ theme: { token } }) => token.colorText};
                }
              }
            }
          }
        }
      }
    }

    footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: ${({ theme: { token } }) => token.marginXS}px;

      .warning-label {
        flex-grow: 1;
        flex-shrink: 0;
        color: ${({ theme: { token } }) => token.colorTextTertiary};
      }

      .ant-form-item {
        margin-left: ${({ theme: { token } }) => token.marginMD}px;
        margin-bottom: 0;

        &:first-child {
          margin-left: 0px;
        }
      }
    }
  }
`;

export const StationTableContainer = styled.div`
  position: relative;
  height: 95%;
  margin-bottom: 20px;

  .ant-table-thead > tr > th {
    padding: 8px 0px;
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-tbody > tr > td {
    padding: 16px 0px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-bottom: 15px;
  padding: 24px 0px 24px 0px;

  h2 {
    margin: 0;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  .search-station-input {
    height: 40px; /* Match the height of EPButton's large size */
    width: 220px;

    .ant-input {
      height: 100%;
    }

    .ant-input-group-addon {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .ant-input-search-button {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ColumnHeaderContent = styled.div`
  position: relative;
  padding: 0 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 80%;
    background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
    opacity: 1;
    left: 0;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  padding: 0 24px 24px 24px;
`;

export const StyledSkeleton = styled(Skeleton)`
  width: fit-content;
  margin-top: 24px;
  margin-bottom: 24px;
  margin-right: 8px;
`;
